import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-store-comment',
  templateUrl: './view-store-comment.component.html',
  styleUrls: ['./view-store-comment.component.scss']
})
export class ViewStoreCommentComponent {
  public desc!:string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    
    public dialogRef: MatDialogRef<ViewStoreCommentComponent>,
  ){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.desc=this.dialogData.desc
  }
}
